import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg";
import { getListSalesToExport } from "../../../services";
import { toast } from "react-toastify";

const ExportarListaServicios = ({ filtros }) => {
    const { t } = useTranslation(['properties', 'common']);
    const params = useParams();
    const url = params['*'].split('/')[0];
    const [isLoading, setIsLoading] = useState(false);

    const exportar = async () => {
        if (isLoading) return;
        setIsLoading(true);
        const toastId = toast.loading(t('common:excel.generatingExcel'));
        try {
            const filtrosAEnviar = url === 'aaff' ? { nif: params.nifFinca } : (filtros || {});
            const data = await getListSalesToExport({ filtros: filtrosAEnviar });

            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const urlObj = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlObj;
            link.setAttribute('download', `servicios_${Date.now()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(urlObj);

            toast.update(toastId, {
                render: t('common:excel.excelSuccess'),
                type: "success",
                isLoading: false,
                autoClose: 3000,
            });
        } catch (error) {
            console.error(error);
            toast.update(toastId, {
                render: t('common:excel.excelError'),
                type: "error",
                isLoading: false,
                autoClose: 5000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            className={`bigBtn ${isLoading ? 'disabled' : ''}`}
            onClick={exportar}
            disabled={isLoading}
        >
            {!isLoading ? (
                <>
                    <img src={Excel} alt={t('management.generateList')} width="30px" />
                    {t('management.generateList')}
                </>
            ) : (
                <>
                    <CircularProgress
                        style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
                    />
                    {t('management.generatingList')}
                </>
            )}
        </button>
    );
};

export default withRouter(ExportarListaServicios);
